/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  ChangeRequestReview,
  ChangeRequestReviewStats,
  ChangeRequestReviewStatus,
  Document,
  EntityId,
  List,
} from "./data-contracts";

/**
 * @description Returns a paginated list of reviews submitted for the change request. Use this to check the current review status and whether all requested reviewers have responded before merging.
 * @tags change-requests-reviews
 * @name GetReviewsByChangeRequestId
 * @summary List all formal reviews submitted for a change request
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/reviews
 * @secure
 */

// @ts-ignore
export const getReviewsByChangeRequestId: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
    /** Filter reviews marked as outdated. */
    outdated?: boolean;
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ChangeRequestReview[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/reviews",
  method: "get",
  streaming: false,
  tags: ["change-requests-reviews"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Submits a formal review decision (approved or changes-requested) on the change request, optionally with a rich-text comment. Use this to complete a review you were requested to perform. Only users who are requested reviewers or have space review permissions can submit a review.
 * @tags change-requests-reviews
 * @name SubmitChangeRequestReview
 * @summary Submit an approve or request-changes review for a change request
 * @request POST:/spaces/{spaceId}/change-requests/{changeRequestId}/reviews
 * @secure
 */

// @ts-ignore
export const submitChangeRequestReview: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** The status of the submitted review. */
    status: ChangeRequestReviewStatus;
    /** Optionally, provide a comment along with the review. */
    comment?: Document;
  };
  RequestHeaders: {};
  ResponseBody: ChangeRequestReview;
  ResponseStatusCode: 201;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/reviews",
  method: "post",
  streaming: false,
  tags: ["change-requests-reviews"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns how many reviews were approved and how many requested changes, for the same reviews the list endpoint returns under the same filters. Use this to summarise where a change request stands without paginating through every review.
 * @tags change-requests-reviews
 * @name GetReviewStatsByChangeRequestId
 * @summary Get review totals for a change request
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/reviews/stats
 * @secure
 */

// @ts-ignore
export const getReviewStatsByChangeRequestId: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
  };
  RequestQuery: {
    /** Filter reviews marked as outdated. */
    outdated?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: ChangeRequestReviewStats;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/reviews/stats",
  method: "get",
  streaming: false,
  tags: ["change-requests-reviews"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves the full details of a single review submission on a change request, including the decision status (approved/changes-requested), reviewer, and any attached comment. Use this when you have a review ID and need its full details.
 * @tags change-requests-reviews
 * @name GetChangeRequestReviewById
 * @summary Get a specific review on a change request by its ID
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/reviews/{reviewId}
 * @secure
 */

// @ts-ignore
export const getChangeRequestReviewById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
    /** The unique ID of the change request review. */
    reviewId: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: ChangeRequestReview;
  ResponseStatusCode: 200 | 404;
} = {
  route:
    "/spaces/{spaceId}/change-requests/{changeRequestId}/reviews/{reviewId}",
  method: "get",
  streaming: false,
  tags: ["change-requests-reviews"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
